<template>
  <div id="content">
    <core-app-view />
      <v-row >
        <v-col cols="12">
          <v-sheet
              class="mx-auto"
              dark
              color="#263238"
              height="250"
          >
            <v-row style="padding-top: 100px" class="fill-height" align="center" align-content="center" justify="center">
              <v-col cols="12" class="text-center">
                <h5 class="display-1 font-weight-thin">{{datafile.title}}</h5>
                <h3 class="font-weight-bold">Demos & Requires</h3>
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>

      <v-row class="fill-height" align="center" justify="start" style="margin-left:4vw; margin-top:5vh;">

            <v-col
                class="text-start"
                cols="12">
              <v-row class="fill-height" align="center" justify="start">
                <v-col class="text-start" cols="12">
                  <h1 class="display-1 font-weight-thin">
                    Motion Recognition
                  </h1>
                </v-col>
                <v-col style="padding-top: 20px" >
                  <v-btn plain large color="primary">
                    <v-icon small>{{icons.mdiEmailSendOutline}}</v-icon>
                    <a :href="link1">
                      <h3 style="margin-left: 5px;">Request</h3>
                    </a>
                  </v-btn>
                </v-col>
                <v-divider light vertical inset/>
                <v-col cols="12" >
                  <body>
                    <div v-html="datafile.about.split('\n').join('<br />')"></div>
                    <v-col cols="12" style="margin-left:4vw; margin-top:5vh;">
                      <video class="center" controls width=60%>

                        <source src="@/assets/hand.mp4"
                                type="video/mp4">

                        Sorry, your browser doesn't support embedded videos.
                      </video>
                    </v-col>
                  </body>
                </v-col> 
              </v-row>

              <v-row class="fill-height" align="center" justify="start" style="margin-top:10vh;">
                <v-col class="text-start" cols="12">
                  <h1 class="display-1 font-weight-thin">
                    with Leap Motion
                  </h1>
                </v-col>
                <v-divider light vertical inset/>
                <v-col cols="12" style="margin-bottom:2vh;">
                  <body>
                  <div v-html="datafile.updates.split('\n').join('<br />')"></div>
                  </body>
                </v-col>
                <v-col cols="12" style="margin-left:4vw; margin-bottom:5vh;">
                  <video controls width=60% >

                    <source src="@/assets/leap.mp4"
                            type="video/mp4">

                    Sorry, your browser doesn't support embedded videos.
                  </video>
                </v-col>
              </v-row>

            </v-col>

      </v-row>
  </div>
</template>

<script>
import {mdiEmailSendOutline, mdiArrowUp} from '@mdi/js'

export default {
  name: 'ContentComponent',
  data: () => ({
    icons: {
      mdiEmailSendOutline, mdiArrowUp
    },
    link1: "https://forms.gle/R2m661HLwxYQeLta9",
    publicPath: process.env.BASE_URL,
    imgPath: '../assets/sketchscope.png',
  }),
  props: {
    datafile: Object,
  },

  components:{
    CoreAppView: () => import('@/components/core/AppView')
  },
}
</script>
